import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-media-play-icon',
  templateUrl: './media-play.component.html'
})
export class MediaPlayComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
